import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Form, Input, Typography, Button, Flex } from "antd";
import { forgotPassword } from "../../../../../redux/services/auth/authServices";
import { baseRouteMaker, routes } from "../../../../../constants/routeConsts";
import RequiredLabel from "../../../../common/required-label/RequiredLabel";
import { colors } from "../../../../../constants/colors";
import { sanitizeDataTypeClientSide } from "../../../../../utils/utils";
import styles from "./ForgotPassword.module.scss";
const { Title } = Typography;

const ForgotPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    if (values) {
      let forgotPasswordBody = {
        email: values.email,
      };
      dispatch(forgotPassword(forgotPasswordBody, navigate, setLoading));
    }
  };
  return (
    <>
      <Flex vertical gap="1rem"  className={styles.forgotPasswordContainer}>
        <Title level={1} style={{color:colors.primaryColor}}>
          {t("ForgotPassword.title")}
        </Title>
        <Title level={4} type="secondary" style={{ margin : 0 }}>
          {t("ForgotPassword.subTitle")}
        </Title>
        <Form
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
          requiredMark={false}
        >
          <Flex vertical gap="10rem">
            <div>
            <Form.Item
              label={
                <RequiredLabel
                  text={t("ForgotPassword.emailLabel")}
                  required={true}
                />
              }
              name="email"
              rules={[
                {
                  type: t("ForgotPassword.typeEmail"),
                  message: t("ForgotPassword.emailValidation"),
                },
                {
                  required: true,
                  message: t("ForgotPassword.emailErrorMessage"),
                },
              ]}
              normalize={(value) => sanitizeDataTypeClientSide(value)}
            >
              <Input placeholder={t("ForgotPassword.emailPlaceholder")} />
            </Form.Item>
          </div>

            <Flex gap="1rem" vertical>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            style={{ width : "100%" }}
          >
            {t("ForgotPassword.sendOtp")}
          </Button>

          <Button
            type="default"
            style={{ width : "100%" }}
            onClick={() => navigate(baseRouteMaker(routes.SIGN_IN))}
          >
            {t("ForgotPassword.goBack")}
          </Button>
          </Flex>

          </Flex>
        </Form>
      </Flex>
    </>
  );
};

export default ForgotPassword;
